import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  skill: {
    id: 'advance.analytics.skill.label',
    defaultMessage: 'Skill',
  },
  enrollments: {
    id: 'advance.analytics.enrollments.label',
    defaultMessage: 'Enrollments',
  },
  completions: {
    id: 'advance.analytics.completions.label',
    defaultMessage: 'Completions',
  },
  date: {
    id: 'advance.analytics.date.label',
    defaultMessage: 'Date',
  },
  course: {
    id: 'advance.analytics.course.label',
    defaultMessage: 'Course',
  },
  subject: {
    id: 'advance.analytics.subject.label',
    defaultMessage: 'Subject',
  },
  learningHours: {
    id: 'advance.analytics.learning.hours.label',
    defaultMessage: 'Learning Hours',
  },
  'Common Skill': {
    id: 'advance.analytics.common.skill.label',
    defaultMessage: 'Common Skill',
  },
  'Specialized Skill': {
    id: 'advance.analytics.specialized.skill.label',
    defaultMessage: 'Specialized Skill',
  },
  'Hard Skill': {
    id: 'advance.analytics.hard.skill.label',
    defaultMessage: 'Hard Skill',
  },
  'Soft Skill': {
    id: 'advance.analytics.soft.skill.label',
    defaultMessage: 'Soft Skill',
  },
  Certification: {
    id: 'advance.analytics.certification.label',
    defaultMessage: 'Certification',
  },
});

export default messages;
